function baseHasIn(object,key){return null!=object&&key in Object(object)}module.exports=baseHasIn;